/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

export default class VollstaendigerName {
    public constructor(private readonly name: string) { }

    public istGueltig() {
        return this.name.trim().length > 2 && this.name.indexOf(" ") > 0;
    }

    public toString() {
        return this.name;
    }

    public static von(vorname?: string, nachname?: string): VollstaendigerName {
        let name = "";
        if (vorname) {
            name += vorname + " ";
        }

        if (nachname) {
            name += nachname;
        }

        return new VollstaendigerName(name);
    }
}